module.exports = __webpack_public_path__ + "static/img/avatarTeam.8247e50a.png";